import React from "react";
import PropTypes from "prop-types";
import Link from "gatsby-link";
import { Box, Flex } from "rebass";
import {
  Head,
  H2,
  CardLayout,
  Main,
  PageSection,
  UpdateCard,
  PrimaryButton,
  SliceZone,
} from "components";
import {
  CalloutCards,
  ExternalUpdates,
  Form,
  Hero,
  InternalUpdates,
  Quote,
  RichText,
  SideBySide,
  Stats,
} from "slices"
import moment from "moment";

let linkResolver = function (doc) {
  return "/" + doc.type;
};

class LandingPage extends React.Component {
  static contextTypes = {
    setAltLanguages: PropTypes.func,
  };
  componentDidMount() {
    if (this.props.data.page.alternate_languages) {
      this.context.setAltLanguages(this.props.data.page.alternate_languages);
    } else {
      this.context.setAltLanguages(undefined);
    }
  }
  render() {
    let json = undefined;
    if (this.props.data.page.raw) {
      json = JSON.parse(this.props.data.page.raw);
    }
    let showInactive = false;
    if (this.props.data.campaignProjects) {
      this.props.data.campaignProjects.edges.forEach((edge) => {
        if (
          edge.node.data.status === "Inactive" ||
          edge.node.data.status === "Canceled" ||
          edge.node.data.status === "Archived"
        ) {
          showInactive = true;
        }
      });
    }
    if (this.props.data.campaignProjects2) {
      this.props.data.campaignProjects2.edges.forEach((edge) => {
        if (
          edge.node.data.status === "Inactive" ||
          edge.node.data.status === "Canceled" ||
          edge.node.data.status === "Archived"
        ) {
          showInactive = true;
        }
      });
    }
    if (this.props.data.campaignProjects3) {
      this.props.data.campaignProjects3.edges.forEach((edge) => {
        if (
          edge.node.data.status === "Inactive" ||
          edge.node.data.status === "Canceled" ||
          edge.node.data.status === "Archived"
        ) {
          showInactive = true;
        }
      });
    }
    return (
      <Box
        bg="white"
        style={
          this.props.transition ? this.props.transition.style : { opacity: 0 }
        }
      >
        <Head
          source={{
            meta_title: [
              {
                text:
                  json.data.seo_title !== undefined
                    ? json.data.seo_title[0]
                      ? json.data.seo_title[0].text
                      : ""
                    : "",
              },
            ],
            meta_description: [
              {
                text:
                  json.data.seo_description !== undefined
                    ? json.data.seo_description
                    : "",
              },
            ],
            social_sharing_image: {
              url:
                json.data.seo_image !== undefined
                  ? json.data.seo_image.url
                  : "",
            },
          }}
        />
        <Main>
          <SliceZone
            content={json.data.body}
            slices={{
              callout_cards: CalloutCards,
              external_updates: ExternalUpdates,
              form: Form,
              hero: Hero,
              internal_updates: InternalUpdates,
              quote: Quote,
              rich_text: RichText,
              side_by_side: SideBySide,
              stats: Stats
            }}
            sliceProps={{ updates: this.props.data.updates }} />
     
          {(this.props.data.campaignUpdates ||
            this.props.data.campaign2Updates ||
            this.props.data.campaign3Updates ||
            this.props.data.campaign4Updates) && (
            <PageSection column="true" borderTop="true">
              <H2
                children={
                  json.lang === "en-us"
                    ? "Related Updates"
                    : json.lang === "es-mx"
                    ? "Noticias"
                    : "التحديثات ذات الصلة"
                }
                mb={5}
                fontSize={[4, 5]}
              />
              <CardLayout w={1 / 1}>
                {[
                  ...(this.props.data.campaignUpdates
                    ? this.props.data.campaignUpdates.edges
                    : []),
                  ...(this.props.data.campaign2Updates
                    ? this.props.data.campaign2Updates.edges
                    : []),
                  ...(this.props.data.campaign3Updates
                    ? this.props.data.campaign3Updates.edges
                    : []),
                  ...(this.props.data.campaign4Updates
                    ? this.props.data.campaign4Updates.edges
                    : []),
                ]
                  .sort(function (a, b) {
                    if (
                      moment(a.node.data.publish_date).utc() <
                      moment(b.node.data.publish_date).utc()
                    )
                      return 1;
                    if (
                      moment(a.node.data.publish_date).utc() >
                      moment(b.node.data.publish_date).utc()
                    )
                      return -1;
                    return 0;
                  })
                  .slice(0, 4)
                  .map((update, index) => (
                    <UpdateCard key={"project" + index} object={update.node} />
                  ))}
              </CardLayout>
              <Flex width="100%" justify="center">
                <Box pt={6}>
                  <PrimaryButton
                    children={
                      json.lang === "en-us"
                        ? "View More"
                        : json.lang === "es-mx"
                        ? "Más noticias"
                        : "عرض المزيد"
                    }
                    is={Link}
                    to={
                      "/" +
                      this.props.data.page.lang +
                      "/updates/?campaign=" +
                      this.props.data.page.prismicId
                    }
                    aria-label="View more updates"
                  />
                </Box>
              </Flex>
            </PageSection>
          )}
        </Main>
      </Box>
    );
  }
}

export default LandingPage;

export const query = graphql`
  query LandingPageQuery($id: String!) {
    page: prismicDocument(prismicId: { eq: $id }) {
      raw
      uid
      prismicId
      id
      lang
      data {
        title {
          type
          text
        }
      }
      alternate_languages {
        uid
        lang
        type
      }
    }
    updates: allPrismicDocument(
      filter: {
        type: { eq: "update" }
        uid: { ne: "hidden-update" }
        data: { landing_page: { id: { eq: $id } } }
      }
    ) {
      edges {
        node {
          uid
          type
          lang
          last_publication_date
          data {
            publish_date
            region {
              uid
            }
            title {
              text
            }
            description {
              text
            }
            header_image {
              url
              quarter {
                url
              }
              half {
                url
              }
              thumb {
                url
              }
            }
          }
        }
      }
    }
  
  }
`;



// WEBPACK FOOTER //
// ./src/layouts/landing_page.js